import { z } from 'zod';

/**
 * Edição parcial a partir do schema de criação: todos os campos ficam opcionais e os valores
 * padrão (`.default()`) são removidos. No zod 4, `.partial()` ainda aplicaria o padrão aos campos
 * ausentes, e uma edição de um campo zeraria os outros (ex.: prioridade voltando para "média").
 */
export function patchOf<S extends z.ZodRawShape>(
  schema: z.ZodObject<S>,
): ReturnType<z.ZodObject<S>['partial']> {
  const shape: Record<string, z.ZodType> = {};
  for (const [key, field] of Object.entries(schema.shape) as [string, z.ZodType][]) {
    const inner = field instanceof z.ZodDefault ? (field.unwrap() as z.ZodType) : field;
    shape[key] = inner.optional();
  }
  return z.object(shape) as unknown as ReturnType<z.ZodObject<S>['partial']>;
}
